module.exports = __webpack_public_path__ + "fonts/dFa4ZfeM_74wlPZtksIFaj8K8VSMdFJ6dZX9.woff2";